
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"people","fill":"rgba(0,0,0,0)","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M18 7.16a.605.605 0 00-.19 0 2.585 2.585 0 11.19 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M16.97 14.44a5.635 5.635 0 003.94-.72 1.911 1.911 0 000-3.42 5.67 5.67 0 00-3.97-.71"}}),_c('g',{attrs:{"data-name":"Group"}},[_c('path',{attrs:{"data-name":"Vector","d":"M5.97 7.16a.605.605 0 01.19 0 2.585 2.585 0 10-.19 0zM7.003 14.44a5.635 5.635 0 01-3.94-.72 1.911 1.911 0 010-3.42 5.67 5.67 0 013.967-.71"}})]),_c('g',{attrs:{"data-name":"Group"}},[_c('path',{attrs:{"data-name":"Vector","d":"M12 14.63a.605.605 0 00-.19 0 2.585 2.585 0 11.19 0zM9.09 17.78a1.911 1.911 0 000 3.42 5.677 5.677 0 005.82 0 1.911 1.911 0 000-3.42 5.723 5.723 0 00-5.82 0z"}})])])])
          )
        }
      }
    